module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero2.png?124ee2a8";